/**
 * @module config/appConfig
 * @description Central study configuration – modes, phases, colours, and flags.
 */

/** @enum {string} Experimental conditions (explanation types). */
export const CONFIGS = {
  MODE_1: "NO EXPLANATION",
  MODE_2: "SIMPLE VISUAL",
  MODE_3: "Interactive Textual XAI method",
  MODE_4: "Interactive Visual XAI method",
  MODE_5: "Interactive Complementary XAI method",
};

/** Numeric condition codes (for URL ?cond=0..4) → mode strings. */
export const CONDITION_MAP = {
  "0": CONFIGS.MODE_1,
  "1": CONFIGS.MODE_2,
  "2": CONFIGS.MODE_3,
  "3": CONFIGS.MODE_4,
  "4": CONFIGS.MODE_5,
};

/** @enum {string} Study phases mapped to image folders. */
export const PHASES = {
  PHASE_1: "Baseline",
  PHASE_2: "Erroneous",
  PHASE_3: "Recovery",
};

/** Human-friendly phase display names (what participants see). */
export const PHASE_DISPLAY_NAMES = {
  Baseline: "Tenerife Trip",
  Erroneous: "Hiking Trip in Austria",
  Recovery: "Norway Trip",
};

/** Ordered list of phase names (drives navigation). */
export const PHASE_ORDER = Object.values(PHASES);

/** Segment highlight colours keyed by index. */
export const COLORS = {
  0: "#1e3a8a",
  1: "#4c1d95",
  2: "#065f46",
  3: "#7c2d12",
};

export const NEON_COLORS = {
  0: "#1e3a8a",
  1: "#4c1d95",
  2: "#065f46",
  3: "#7c2d12",
};

/** Default mode used when no Prolific assignment is available in debug. */
export const CURRENT_MODE = CONFIGS.MODE_5;

/** Maximum images shown per phase. */
export const MAX_IMAGES_PER_PHASE = 10;

/**
 * Enable debug helpers (form pre-fill buttons, manual mode selection).
 * Set to `false` for production / Prolific deployment.
 */
export const DEBUG_MODE = false;
